import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import block from 'bem-cn'

import { MODAL_ROUTE_PATH, MODAL_ROUTE_URLS } from 'router/modalRoutes'
import { ROUTE_URLS } from 'router/routes'

import { ReactComponent as CloseSVG } from 'shared/img/cross.svg'

import { useMediaDevice, useModalContext } from '@bcraft-frontend-lib/core'
import { getRouteParamsByStrings } from 'shared/utils/getRouteParamsByStrings'

import { selectLocaleDict } from 'features/locale/selectors'

import { ReactComponent as Live1Icon } from './img/live1.svg'
import { ReactComponent as Live2Icon } from './img/live2.svg'
import { ReactComponent as Sport1Icon } from './img/sport1.svg'
import { ReactComponent as Sport2Icon } from './img/sport2.svg'

import './ChooseSport.scss'

export type ChooseSportType = 'sport' | 'live' | 'bets'

const b = block('choose-sport')

export const ChooseSport = ({ path }: { path: string }) => {
  const history = useHistory()
  const { closeModal, setOpenedModals } = useModalContext()
  const isMobile = useMediaDevice({ query: 'maxTablet' })

  const params: { type: ChooseSportType } | null = getRouteParamsByStrings(MODAL_ROUTE_PATH.CHOOSE_SPORT, path)

  const locale = useSelector(selectLocaleDict, shallowEqual).common

  const onChooseSport = (route: string) => {
    history.push(route)
  }

  return (
    <div className={b()}>
      <div className={b('header')}>
        <h2 className={b('header-title')}>{locale.chooseSport}</h2>
        <CloseSVG onClick={closeModal(MODAL_ROUTE_URLS.CHOOSE_SPORT(params?.type!!))} className={b('header-cross')} />
      </div>

      <div className={b('content')}>
        {params?.type === 'live' && (
          <>
            <div
              className={b('sport')}
              onClick={() => onChooseSport(ROUTE_URLS.DIGITAIN_SPORT_PAGE(isMobile ? 'Live' : 'Overview'))}>
              <Live1Icon className={b('sport-icon')} />
              <span className={b('sport-text')}>{locale.live} 1</span>
            </div>
            {/* <div className={b('sport')} onClick={() => onChooseSport(ROUTE_URLS.SOFTION_SPORT_LIVE())}> */}
            {/*  <Live2Icon className={b('sport-icon')} /> */}
            {/*  <span className={b('sport-text')}>{locale.live} 2</span> */}
            {/* </div> */}
            <div className={b('sport')} onClick={() => onChooseSport(ROUTE_URLS.BETBY_SPORT('live'))}>
              <Live1Icon className={b('sport-icon')} />
              <span className={b('sport-text')}>{locale.live} 2</span>
            </div>
            {/* <div className={b('sport')} onClick={() => onChooseSport(ROUTE_URLS.ALTENAR_SPORT('live'))}> */}
            {/*  <Live2Icon className={b('sport-icon')} /> */}
            {/*  <span className={b('sport-text')}>{locale.live} 4</span> */}
            {/* </div> */}
          </>
        )}
        {params?.type === 'sport' && (
          <>
            <div className={b('sport')} onClick={() => onChooseSport(ROUTE_URLS.DIGITAIN_SPORT_PAGE('Home'))}>
              <Sport1Icon className={b('sport-icon')} />
              <span className={b('sport-text')}>{locale.sport} 1</span>
            </div>
            {/* <div className={b('sport')} onClick={() => onChooseSport(ROUTE_URLS.SOFTION_SPORT())}> */}
            {/*  <Sport2Icon className={b('sport-icon')} /> */}
            {/*  <span className={b('sport-text')}>{locale.sport} 2</span> */}
            {/* </div> */}
            <div className={b('sport')} onClick={() => onChooseSport(ROUTE_URLS.BETBY_SPORT())}>
              <Sport1Icon className={b('sport-icon')} />
              <span className={b('sport-text')}>{locale.sport} 2</span>
            </div>
            {/* <div className={b('sport')} onClick={() => onChooseSport(ROUTE_URLS.ALTENAR_SPORT())}> */}
            {/*  <Sport2Icon className={b('sport-icon')} /> */}
            {/*  <span className={b('sport-text')}>{locale.sport} 4</span> */}
            {/* </div> */}
          </>
        )}

        {params?.type === 'bets' && (
          <>
            <div className={b('sport')} onClick={() => onChooseSport(ROUTE_URLS.DIGITAIN_SPORT_PAGE('BetsHistory'))}>
              <Sport1Icon className={b('sport-icon')} />
              <span className={b('sport-text')}>{locale.sport} 1</span>
            </div>
            {/* <div */}
            {/*  className={b('sport')} */}
            {/*  onClick={() => setOpenedModals([MODAL_ROUTE_URLS.PROFILE_DESKTOP('betHistory_2')])}> */}
            {/*  <Sport2Icon className={b('sport-icon')} /> */}
            {/*  <span className={b('sport-text')}>{locale.sport} 2</span> */}
            {/* </div> */}
            <div className={b('sport')} onClick={() => onChooseSport(ROUTE_URLS.BETBY_SPORT('bets'))}>
              <Sport1Icon className={b('sport-icon')} />
              <span className={b('sport-text')}>{locale.sport} 2</span>
            </div>
            {/* <div className={b('sport')} onClick={() => onChooseSport(ROUTE_URLS.ALTENAR_SPORT('mybets'))}> */}
            {/*  <Sport2Icon className={b('sport-icon')} /> */}
            {/*  <span className={b('sport-text')}>{locale.sport} 4</span> */}
            {/* </div> */}
          </>
        )}
      </div>
    </div>
  )
}
